
import { lazy, ComponentType, ReactElement } from 'react';
import { RouteObject } from 'react-router-dom';
import SuspenseWrapper from '../components/SuspenseWrapper';

const Home = lazy<ComponentType>(() => import('../pages/home/page'));
const NotFound = lazy<ComponentType>(() => import('../pages/NotFound'));
const Dashboard = lazy<ComponentType>(() => import('../pages/dashboard/page'));

const createLazyRoute = (Component: ComponentType): ReactElement => {
  return <SuspenseWrapper><Component /></SuspenseWrapper>;
};

const routes: RouteObject[] = [
  {
    path: '/',
    element: createLazyRoute(Dashboard),
  },
  {
    path: '/home',
    element: createLazyRoute(Home),
  },
  {
    path: '*',
    element: createLazyRoute(NotFound),
  },
];

export default routes;
